import { colors } from "@areahub/theme";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { Link } from "@ui/components/link";
import { IndustriesMenu } from "./nav-content";

export const IndustriesDropdownMenu = (props: IndustriesMenu) => {
  return (
    <>
      <Box
        display={{
          base: "none",
          lg: "block",
        }}
      >
        <Menu>
          <MenuButton
            color={colors.enterpriseColors.blue["200"]}
            fontWeight={"semibold"}
          >
            {props.buttonLabel}
          </MenuButton>
          <MenuList w={"65%"}>
            {props?.industriesMenuItem.map((item, idx) => (
              <MenuItem
                key={`industries-menu-desktop-option-${idx}`}
                color={colors.enterpriseColors.blue["200"]}
                fontWeight={"semibold"}
              >
                <Link
                  href={item.url}
                  _hover={{
                    borderBottom: `3px solid ${colors.enterpriseColors.blue["100"]}`,
                    textDecor: "none",
                  }}
                >
                  {item.option}
                </Link>
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Box>
      <Box
        display={{
          lg: "none",
        }}
      >
        <Accordion allowToggle w={"250px"}>
          <AccordionItem border={0}>
            <AccordionButton p={0}>
              <Box as="span" flex="1" textAlign="left">
                {props.buttonLabel}
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={4} display={"flex"} flexDir={"column"}>
              {props?.industriesMenuItem.map((item, idx) => (
                <Link
                  href={item.url}
                  key={`industry-dropdown-mobile-option-${idx}`}
                  py={1}
                  onClick={props.onToggle}
                >
                  {item.option}
                </Link>
              ))}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Box>
    </>
  );
};
